import styled from 'styled-components';

const UnderlineInputField = styled.div<{ active: boolean }>`
  background-color: ${props => (props.active ? '#f47457' : 'transparent')};
  height: 2px;
  width: 100%;
`;

export default UnderlineInputField;
